// Curated design tokens for the Design Decor interactive configurator.
// Each option includes a display name and a hex value used by SVG fills.

export const KITCHEN_SWATCHES = {
  cabinet: [
    { id: "carrara-white", name: "Carrara White", hex: "#F3F1EC" },
    { id: "ivory-cream", name: "Ivory Cream", hex: "#E7DDCB" },
    { id: "walnut-crema", name: "Walnut Crema", hex: "#7B5F4A" },
    { id: "matte-charcoal", name: "Matte Charcoal", hex: "#3A3A3A" },
    { id: "espresso", name: "Dark Espresso", hex: "#2A1C14" },
    { id: "sage", name: "Sage Olive", hex: "#7E8A6B" },
    { id: "ink-black", name: "Ink Black", hex: "#111111" },
  ],
  countertop: [
    { id: "carrara", name: "Carrara Marble", hex: "#EEEAE0" },
    { id: "calacatta", name: "Calacatta Gold", hex: "#E5DCC7" },
    { id: "quartz-grey", name: "Quartz Grey", hex: "#B7B3AC" },
    { id: "black-granite", name: "Black Granite", hex: "#1A1A1A" },
    { id: "terrazzo", name: "Warm Terrazzo", hex: "#D9C8B4" },
  ],
  backsplash: [
    { id: "subway-cream", name: "Subway Cream", hex: "#EFE7D6" },
    { id: "subway-white", name: "Subway White", hex: "#F4F2EC" },
    { id: "moss", name: "Moss Tile", hex: "#5C6A4F" },
    { id: "terracotta", name: "Terracotta", hex: "#C48E75" },
    { id: "midnight", name: "Midnight Tile", hex: "#1C1F25" },
  ],
  wall: [
    { id: "linen", name: "Linen", hex: "#EAE2D2" },
    { id: "shell", name: "Shell", hex: "#F2EDE3" },
    { id: "clay", name: "Clay", hex: "#C9B49A" },
    { id: "graphite", name: "Warm Graphite", hex: "#3D3733" },
    { id: "soot", name: "Soot", hex: "#16140F" },
  ],
  handle: [
    { id: "brushed-brass", name: "Brushed Brass", hex: "#B8996F" },
    { id: "matte-black", name: "Matte Black", hex: "#161616" },
    { id: "satin-nickel", name: "Satin Nickel", hex: "#B6BBC0" },
    { id: "antique-bronze", name: "Antique Bronze", hex: "#6E4E36" },
  ],
  wood: [
    { id: "natural-oak", name: "Natural Oak", hex: "#C9A57A" },
    { id: "walnut", name: "Walnut", hex: "#7B5F4A" },
    { id: "smoked-ash", name: "Smoked Ash", hex: "#5B4D44" },
    { id: "honey", name: "Honey Teak", hex: "#B98856" },
  ],
  finish: [
    { id: "matte", name: "Matte" },
    { id: "gloss", name: "Gloss" },
  ],
};

export const KITCHEN_PRESETS = [
  {
    id: "modern-white-luxury",
    name: "Modern White Luxury",
    photo:
      "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg?auto=compress&cs=tinysrgb&w=1400",
    filter: "saturate(1.02) brightness(1.02)",
    config: {
      cabinet: "carrara-white",
      countertop: "carrara",
      backsplash: "subway-white",
      wall: "shell",
      handle: "brushed-brass",
      wood: "natural-oak",
      finish: "gloss",
    },
  },
  {
    id: "walnut-contemporary",
    name: "Walnut Contemporary",
    photo:
      "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=1400&auto=format&fit=crop&q=80",
    filter: "saturate(1.05) brightness(1.0)",
    config: {
      cabinet: "walnut-crema",
      countertop: "calacatta",
      backsplash: "subway-cream",
      wall: "linen",
      handle: "brushed-brass",
      wood: "walnut",
      finish: "matte",
    },
  },
  {
    id: "matte-grey-premium",
    name: "Matte Grey Premium",
    photo:
      "https://images.pexels.com/photos/3214064/pexels-photo-3214064.jpeg?auto=compress&cs=tinysrgb&w=1400",
    filter: "saturate(0.92) brightness(0.96)",
    config: {
      cabinet: "matte-charcoal",
      countertop: "quartz-grey",
      backsplash: "midnight",
      wall: "graphite",
      handle: "satin-nickel",
      wood: "smoked-ash",
      finish: "matte",
    },
  },
  {
    id: "beige-minimal",
    name: "Beige Minimal",
    photo:
      "https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=1400&auto=format&fit=crop&q=80",
    filter: "sepia(0.08) saturate(1.05) brightness(1.02)",
    config: {
      cabinet: "ivory-cream",
      countertop: "terrazzo",
      backsplash: "subway-cream",
      wall: "clay",
      handle: "antique-bronze",
      wood: "honey",
      finish: "matte",
    },
  },
  {
    id: "dark-luxury",
    name: "Dark Luxury",
    photo:
      "https://images.pexels.com/photos/2089696/pexels-photo-2089696.jpeg?auto=compress&cs=tinysrgb&w=1400",
    filter: "saturate(1.08) brightness(0.95) contrast(1.04)",
    config: {
      cabinet: "espresso",
      countertop: "black-granite",
      backsplash: "midnight",
      wall: "soot",
      handle: "brushed-brass",
      wood: "walnut",
      finish: "matte",
    },
  },
  {
    id: "scandinavian-light",
    name: "Scandinavian Light",
    photo:
      "https://images.unsplash.com/photo-1556910096-6f5e72db6803?w=1400&auto=format&fit=crop&q=80",
    filter: "saturate(1.0) brightness(1.04)",
    config: {
      cabinet: "carrara-white",
      countertop: "carrara",
      backsplash: "subway-cream",
      wall: "linen",
      handle: "matte-black",
      wood: "natural-oak",
      finish: "matte",
    },
  },
];

export const WARDROBE_SWATCHES = {
  laminate: [
    { id: "walnut", name: "Walnut", hex: "#7B5F4A" },
    { id: "white-oak", name: "White Oak", hex: "#D9C39B" },
    { id: "matte-black", name: "Matte Black", hex: "#141414" },
    { id: "beige-luxury", name: "Beige Luxury", hex: "#D9C7AE" },
    { id: "grey", name: "Cement Grey", hex: "#8C8780" },
    { id: "espresso", name: "Espresso", hex: "#2C1E16" },
  ],
  doorStyle: [
    { id: "sliding", name: "Sliding" },
    { id: "hinged", name: "Hinged" },
  ],
  glass: [
    { id: "none", name: "No Glass", hex: "transparent" },
    { id: "smoked", name: "Smoked", hex: "rgba(20,20,20,0.55)" },
    { id: "bronze", name: "Bronze Tint", hex: "rgba(120,80,40,0.4)" },
    { id: "clear", name: "Clear", hex: "rgba(220,230,235,0.35)" },
  ],
  wood: [
    { id: "natural-oak", name: "Natural Oak", hex: "#C9A57A" },
    { id: "walnut", name: "Walnut", hex: "#7B5F4A" },
    { id: "smoked-ash", name: "Smoked Ash", hex: "#5B4D44" },
    { id: "teak", name: "Teak", hex: "#A36F44" },
  ],
  handle: [
    { id: "brushed-brass", name: "Brushed Brass", hex: "#B8996F" },
    { id: "matte-black", name: "Matte Black", hex: "#161616" },
    { id: "satin-nickel", name: "Satin Nickel", hex: "#B6BBC0" },
    { id: "recessed", name: "Recessed (none)", hex: "transparent" },
  ],
  wall: [
    { id: "linen", name: "Linen", hex: "#EAE2D2" },
    { id: "shell", name: "Shell", hex: "#F2EDE3" },
    { id: "clay", name: "Clay", hex: "#C9B49A" },
    { id: "graphite", name: "Warm Graphite", hex: "#3D3733" },
    { id: "soot", name: "Soot", hex: "#16140F" },
  ],
};

export const WARDROBE_PRESETS = [
  {
    id: "modern-walnut",
    name: "Modern Walnut",
    photo:
      "https://images.unsplash.com/photo-1558997519-83ea9252edf8?w=1400&auto=format&fit=crop&q=80",
    filter: "saturate(1.05) brightness(0.98)",
    config: {
      laminate: "walnut",
      doorStyle: "sliding",
      glass: "smoked",
      wood: "walnut",
      handle: "brushed-brass",
      wall: "linen",
    },
  },
  {
    id: "white-oak",
    name: "White Oak",
    photo:
      "https://images.pexels.com/photos/7535012/pexels-photo-7535012.jpeg?auto=compress&cs=tinysrgb&w=1400",
    filter: "saturate(1.0) brightness(1.04)",
    config: {
      laminate: "white-oak",
      doorStyle: "hinged",
      glass: "none",
      wood: "natural-oak",
      handle: "matte-black",
      wall: "shell",
    },
  },
  {
    id: "matte-black-premium",
    name: "Matte Black Premium",
    photo:
      "https://images.pexels.com/photos/271624/pexels-photo-271624.jpeg?auto=compress&cs=tinysrgb&w=1400",
    filter: "brightness(0.7) contrast(1.18) saturate(0.85)",
    config: {
      laminate: "matte-black",
      doorStyle: "sliding",
      glass: "smoked",
      wood: "smoked-ash",
      handle: "brushed-brass",
      wall: "graphite",
    },
  },
  {
    id: "beige-luxury",
    name: "Beige Luxury",
    photo:
      "https://images.pexels.com/photos/7535012/pexels-photo-7535012.jpeg?auto=compress&cs=tinysrgb&w=1400",
    filter: "sepia(0.35) saturate(1.1) brightness(1.02)",
    config: {
      laminate: "beige-luxury",
      doorStyle: "hinged",
      glass: "bronze",
      wood: "teak",
      handle: "brushed-brass",
      wall: "clay",
    },
  },
  {
    id: "grey-contemporary",
    name: "Grey Contemporary",
    photo:
      "https://images.pexels.com/photos/271624/pexels-photo-271624.jpeg?auto=compress&cs=tinysrgb&w=1400",
    filter: "saturate(0.85) brightness(1.0) contrast(1.05)",
    config: {
      laminate: "grey",
      doorStyle: "sliding",
      glass: "clear",
      wood: "smoked-ash",
      handle: "satin-nickel",
      wall: "graphite",
    },
  },
];

export const WHATSAPP_NUMBER = "+919739050448";
export const WHATSAPP_DIGITS = "919739050448";

export const PROJECT_TYPES = [
  "Modular Kitchen",
  "Bedroom Wardrobe",
  "Full Home Interior",
  "Living Room",
  "Renovation",
  "Commercial / Office",
];

export const BUDGET_RANGES = [
  "Below ₹3 Lakhs",
  "₹3 – ₹6 Lakhs",
  "₹6 – ₹10 Lakhs",
  "₹10 – ₹20 Lakhs",
  "Above ₹20 Lakhs",
];

export const lookupHex = (collection, id, fallback = "#cccccc") => {
  const item = collection?.find((s) => s.id === id);
  return item?.hex ?? fallback;
};

export const lookupName = (collection, id, fallback = "") => {
  const item = collection?.find((s) => s.id === id);
  return item?.name ?? fallback;
};
